// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SETTINGS = {
    DIALOG: 'settings-dialog',
};